/** BottomNav 탭 활성 여부 판단 */
export function isTabActive(tabPath: string, currentPath: string): boolean {
  if (tabPath === '/') return currentPath === '/';
  // /albums 탭은 /albums, /albums/new, /albums/:id/edit|export|?share=*, /editor(레거시) 모두 활성
  if (tabPath === '/albums') {
    return (
      currentPath === '/albums' ||
      currentPath.startsWith('/albums/') ||
      currentPath === '/editor' ||
      currentPath === '/export'
    );
  }
  return currentPath === tabPath || currentPath.startsWith(tabPath + '/');
}
